import { render, staticRenderFns } from "./marquee2.vue?vue&type=template&id=8d35e034&scoped=true"
import script from "./marquee2.vue?vue&type=script&lang=js"
export * from "./marquee2.vue?vue&type=script&lang=js"
import style0 from "./marquee2.vue?vue&type=style&index=0&id=8d35e034&prod&lang=less"
import style1 from "./marquee2.vue?vue&type=style&index=1&id=8d35e034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d35e034",
  null
  
)

export default component.exports